import { useEffect, useRef, useState } from "react";
import { PayPalScriptProvider, PayPalButtons, FUNDING } from "@paypal/react-paypal-js";
import axios from "axios";

const newIdempotencyKey = () => {
    if (window.crypto && typeof window.crypto.randomUUID === "function") {
        return window.crypto.randomUUID();
    }
    return `${Date.now()}-${Math.random().toString(16).slice(2)}-${Math.random().toString(16).slice(2)}`;
};

const Paypal = ({ payAmount, fundingSource = "paypal" }) => {
    const [configuration, setConfiguration] = useState(null);
    const [configurationError, setConfigurationError] = useState(false);
    const idempotencyKey = useRef(newIdempotencyKey());

    useEffect(() => {
        let mounted = true;
        axios.get("/api/paypal/config.php")
            .then((response) => {
                if (mounted && response.data?.success) {
                    setConfiguration(response.data.data);
                }
            })
            .catch(() => {
                if (mounted) {
                    setConfigurationError(true);
                }
            });
        return () => {
            mounted = false;
        };
    }, []);

    if (configurationError) {
        return <div>PayPal is temporarily unavailable. Please try again later.</div>;
    }
    if (!configuration) {
        return <div>Loading PayPal…</div>;
    }

    return (
        <PayPalScriptProvider options={{
            "client-id": configuration.clientId,
            currency: configuration.currency,
            intent: "capture",
            components: "buttons",
            "enable-funding": "venmo",
        }}>
            <PayPalButtons
                createOrder={() => axios.post("/api/paypal/create-order.php", {
                    amount: payAmount,
                    idempotencyKey: idempotencyKey.current,
                }).then((response) => response.data.data.orderId)}
                onApprove={(data) => axios.post("/api/paypal/capture-order.php", {
                    orderId: data.orderID,
                    idempotencyKey: idempotencyKey.current,
                }).then((response) => {
                    if (response.data.data.status === "RECONCILIATION_REQUIRED") {
                        alert("PayPal completed the payment. We are confirming it on your account; please do not submit another payment.");
                    } else {
                        alert("Payment successfully submitted.");
                    }
                    window.location.href = "https://www.customlawnsofomaha.com";
                })}
                onError={() => {
                    alert("PayPal could not complete the payment. Please try again. If PayPal already shows a charge, do not resubmit it; contact Custom Lawns.");
                }}
                fundingSource={fundingSource === "venmo" ? FUNDING.VENMO : FUNDING.PAYPAL}
            >
                <div>{fundingSource === "venmo" ? "Venmo is unavailable on this device or browser. Please choose another payment method." : "PayPal is unavailable. Please choose another payment method."}</div>
            </PayPalButtons>
        </PayPalScriptProvider>
    );
};

export default Paypal;
